<div *ngIf="totalCount > 0">
  <div class="companyinfo-flex d-flex align-items-center" style="margin-bottom: 20px;">
    <h1 class="companyinfo-datafound mb-0" *ngIf="totalSalaryData && totalSalaryData>0"> {{companyName}} Salaries</h1>
    <span class="clearall-btn text-webbtree-green" (click)="applyFilter('clearall', '')"><i class="fas fa-redo-alt ml-3" ></i></span>
  </div>
  <div class="mb-4 d-flex align-items-center">
    <div class="col pl-0">
      <input data-testid="auto-app-salarylist-input-1" type="text"
        placeholder="Jobtitle"
        [(ngModel)] = "jobtitle"
        (input)="onKeyPress()"
        class="wc-form-control"
        [matAutocomplete]="company_name">
      <mat-autocomplete #company_name="matAutocomplete" (optionSelected)="applyFilter('jobtitle',jobtitle)">
        <mat-option *ngFor="let jt of filteredJobTitleList.slice(0,10)" [value]="jt"
          >
          {{jt}}
        </mat-option>
      </mat-autocomplete>
    </div>
    <div class="col">
    <div>
      <select data-testid="auto-app-salarylist-select-1" (ngModelChange)="applyFilter('currency',$event)" class="wc-form-control wc-select" [(ngModel)]="currency" >
        <option *ngFor="let currency of currencyList" [value]="currency">{{currency}}</option>
      </select>
  
    </div>
    </div>
    <div class="col">
      <select data-testid="auto-app-salarylist-select-2" (ngModelChange)="applyFilter('location',$event)" [(ngModel)]="location" class="wc-form-control wc-select text-capitalize"  >
        <option value="" selected>All Countries</option>
        <option *ngFor="let location of locationsList" [value]="location" >{{location}}</option>
      </select>
    </div>
  </div>
</div>
  <div class="row">
    <div class="col-lg-6 companyinfo-header">
      <p>Designation</p>
    </div>
    <div class="col-lg companyinfo-header">
      <p class="mx-auto" style="width:80%;">Average Annual Salary</p>
    </div>
  </div>
  <div
    class="row companyinfo-expandsal-row"
    [class.noborder-bottom]="count == finalData.length - 1"
    *ngFor="let item of finalData; let count = index"
  >
    <div class="col-lg-6 text-capitalize">
      <p class="mb-1" style="font-weight: 600;">
        {{ item.jobtitle }}
        <span *ngIf="item.finalSalary && item.salcount>1" style="color: #777777"
          >({{ item.salcount }} Salaries)</span
        >
        <span *ngIf="item.finalSalary && item.salcount==1" style="color: #777777"
          >({{ item.salcount }} Salary)</span
        >
      </p>
      <p class="mb-0">
        Avg. Experience: {{ item.experience }} years
        <!-- <span style="color: #777777">({{ item.expcount }})</span> -->
      </p>
    </div>
    <div class="col-lg pt-4" *ngIf="item.finalSalary != 'locked'">
      <!-- <p *ngIf="item.finalSalary">{{currency}} {{ item.finalSalary }}</p> -->
      <p class="gray-text  font-weight-normal" *ngIf="!item.finalSalary">Salary Not Available</p>

      <div *ngIf="item.finalSalary" class="d-flex justify-content-between position-relative">
        <div class="position-relative text-center" style="width: 30%; z-index:1">

          <div class="greendot"></div>
          <div class="salaryText f-12">
            {{currency}} {{ item.finalMinSalary }}
          </div>
        </div>
        <div class="position-relative text-center"  style="width: 30%; margin-top: -20px; z-index:1">

          <div class="salaryText f-14 font-weight-500">
            {{currency}} {{ item.finalSalary }}
          </div>
          <div class="greendot xl"></div>
        </div>
        <div class="position-relative text-center" style="width: 30%; z-index:1">

          <div class="greendot"></div>
          <div class="salaryText f-12">
            {{currency}} {{ item.finalMaxSalary }}
          </div>
        </div>

        <div class='line'>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="totalCount > 0">
    <ngb-pagination class="d-flex justify-content-center"
    [collectionSize]="totalCount"
    [(page)]="activePage"
    [maxSize] = "5"
    [pageSize]="10"
    [boundaryLinks]="true"
    (pageChange)="pagination('page', $event)"></ngb-pagination>
  </div>

<div class="text-center  mb-0 f-16" *ngIf="totalCount == 0">
  <p class="gray-text font-weight-normal">Salary Data Not Available</p>
</div>
